export class CommandParameterTemplate {
  name: string;
  type: string;
  value: any | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.type = payload.type;
      this.value = payload.value;
    }
  }

}
